module.exports = __webpack_public_path__ + "static/logo-2020-83148bd9847bb3eed6e9b0b973207341.png";